/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Premium_SkipInputs */

const en_premium_skip = /** @type {(inputs: Premium_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skip`)
};

const es_premium_skip = /** @type {(inputs: Premium_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omitir`)
};

/**
* | output |
* | --- |
* | "Skip" |
*
* @param {Premium_SkipInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const premium_skip = /** @type {((inputs?: Premium_SkipInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Premium_SkipInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_premium_skip(inputs)
	return en_premium_skip(inputs)
});